module.exports = __webpack_public_path__ + "img/CON2.7929291a.png";